import type { RemainingTO } from '../types';
import { formatHours, MH_UNIT } from './flightDisplay';

const signed = (value: number, formatted: string) =>
  value < 0 ? `−${formatted}` : formatted;

export const isTo100Remaining = (to: RemainingTO | null | undefined) =>
  to?.title === 'ТО-100';

export const hoursOverdue = (to: RemainingTO | null | undefined) =>
  to?.remaining != null && Number(to.remaining) < 0;

export const calendarOverdue = (to: RemainingTO | null | undefined) =>
  isTo100Remaining(to) &&
  to?.calendar_remaining_days != null &&
  Number(to.calendar_remaining_days) < 0;

export const remainingOverdue = (to: RemainingTO | null | undefined) =>
  hoursOverdue(to) || calendarOverdue(to);

export const formatHoursPart = (to: RemainingTO | null) => {
  if (to?.remaining == null) return null;
  const hours = Number(to.remaining);
  if (!Number.isFinite(hours)) return null;
  return signed(hours, formatHours(Math.abs(hours)));
};

export const formatDaysPart = (to: RemainingTO | null) => {
  if (!isTo100Remaining(to) || to?.calendar_remaining_days == null) return null;
  const days = Number(to.calendar_remaining_days);
  if (!Number.isFinite(days)) return null;
  return signed(days, String(Math.abs(days)));
};

/** Подсказка на ожидающей карточке ТО-100: год с последней формы. */
export const formatCalendarWaitingHint = (to: RemainingTO | null) => {
  if (!isTo100Remaining(to) || to?.calendar_remaining_days == null) return null;
  const days = Number(to.calendar_remaining_days);
  if (!Number.isFinite(days)) return null;
  if (days < 0) {
    return `Год с ТО-100 прошёл ${Math.abs(days)} дн назад`;
  }
  return `До года с ТО-100: ${days} дн`;
};

export const hoursUnit = (_to?: RemainingTO | null) => MH_UNIT;

/** Остаток формы: «39.9 м/ч / 46 дн» для ТО-100, иначе «12.5 м/ч». */
export const formatRemainingHoursDays = (to: RemainingTO | null) => {
  const hours = formatHoursPart(to);
  const days = formatDaysPart(to);
  if (hours == null && days == null) return '—';
  if (hours == null) return `${days} дн`;
  if (days == null) return `${hours} ${hoursUnit(to)}`;
  return `${hours} ${hoursUnit(to)} / ${days} дн`;
};
